import get from 'lodash/get';

import LAZY_LOAD_MENU_SIZE from 'constants/menu/lazyLoadMenuSettings';
import { getMenuLength } from 'helpers/getMenuLength';

export function selectShouldLazyLoadMenu(menu) {
  return getMenuLength(menu) >= LAZY_LOAD_MENU_SIZE;
}

export function selectMenuItemDetailsBySlug(menuDetails, menuItemSlug) {
  const menuItemDetails = menuDetails.find(
    menuItemDetails => menuItemDetails.slug === menuItemSlug
  );
  return {
    ...menuItemDetails,
    imageSrc: menuItemDetails?.images?.[0]?.url ?? ''
  };
}

export function selectMenuHeroImage(menu) {
  return get(menu, 'images[0]', {});
}
